"use client";

import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import MobileServices from "src/components/Common/NavigationSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import { mobileAppMock, mobileAppServices } from "src/utils/mock/mobileAppMock";
import { flutterStatsData, flutterTechnologiesData } from "src/utils/mock/webAppData";
import { mobileAppAboutData, MobileAppHeroData, mobileDevelopSolutionsAndProcessData, mobilePortfolioData } from "src/utils/mock/mobileAppDevelopmentData";

export default function MobileAppDevelopment({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const mobileProjects = liveProjects.filter((project) => {
    const isMobilePlatform = project.platforms?.toLowerCase().includes("mobile");
    const hasMobileTech = project.technologies?.some((tech) => ["react native", "flutter", "swift", "kotlin", "android", "ios"].includes(tech.name.toLowerCase()));

    return isMobilePlatform || hasMobileTech;
  });

  const filteredData = {
    ...finalCaseStudies,
    projects: {
      ...finalCaseStudies?.projects,
      liveProjects: mobileProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={MobileAppHeroData} />
      <TechStats stats={flutterStatsData} />
      <MobileServices data={mobileAppServices} leftHeading="Complete Mobile" rightHeading=" App Solutions" />
      <WhyChooseUs data={mobileDevelopSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-text-primary px-6! md:px-12! relative overflow-hidden font-sans ">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-500/5 dark:bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-500/5 dark:bg-blue-950/10 blur-[150px] -z-10 rounded-full" />
        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={flutterTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Mobile App Development" sections={mobileAppAboutData} />
        </div>
      </section>
      <FAQSection faqs={mobileAppMock} />
      <CommonContactSection />
    </div>
  );
}
